import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SampleInformation from "./SampleInformation";
import { wpsDqcNextStep, wpsDqcPrevStep } from "../../../store";
import Confirmation from "./Confirmation";
import { Navigate, useNavigate } from "react-router-dom";
import { url } from "../../../configlink";

const WpsDqcForm = () => {
  const page = useSelector((state) => state.wpsDqcForm.page);
  const userState = useSelector((state) => state.user.user)
  let nav = useNavigate()
  const dispatch = useDispatch();


  const handlePrevPage = () => {
    dispatch(wpsDqcPrevStep());
  };
  const handleNextPage = () => {
    dispatch(wpsDqcNextStep());
  };

  useEffect(() => {
      if(window.innerWidth < 480) {
        return <Navigate to='/dashboard' />;
      }
      else {
        wpsDqcValidity()
      }
    }, [])


    const wpsDqcValidity = () => {
    let userId = userState.UserId
    try {
      fetch(`${url}/api/users/wpsDqcCheck?userId=${userId}`, {
        method:"GET",
        credentials: "include",
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // }
      })
      .then(res => res.json())
      .then(data => {
        if(data === false){
          nav('/dashboard')
        }
      }) 
    }
    catch (err) {
      console.error(err)
    }
    }

  const PageDisplay = () => {

    switch (page) {
      case 0:
        return (
          <SampleInformation
            page={page}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            steps={2}
          />
        );
      case 1:
        return <Confirmation page={page} steps={2} />;

      default:
        break;
    }
  };

  return (
    <>
      <PageDisplay />
    </>
  );
};

export default WpsDqcForm;
